<template>
  <v-content>
    <v-toolbar app dark color="primary">
      <v-avatar :tile=true class="hidden-sm-and-down">
        <img src="https://cdn3.iconfinder.com/data/icons/humano2/128x128/apps/stock_new-24h-appointment.png" alt="Vuetify.js"/>
      </v-avatar>
      <v-toolbar-title>Reserva de turnos <router-link :to="{name: 'portada'}" tag="button">
            <p class="text-right">Salir</p>
          </router-link></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title></v-toolbar-title>
    </v-toolbar>
    <v-container>
        <v-layout>
          <v-flex>
            <v-card class="elevation-21 mt-3">
              <v-form>
                <v-container fluid>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md3>
                      <h1 class="title pt-3">
                        <v-icon>search</v-icon>
                        Filtros de búsqueda
                      </h1>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-autocomplete
                          :items="clasificaciones"
                          prepend-icon="healing"
                          label="Tramites"
                          name="clasificacion"
                          clearable
                          @change="onTurnoClasificacionChange"
                          >
                          <template slot="no-data">
                            <v-list-tile>
                              Tramite no encontrado
                            </v-list-tile>
                          </template>
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
              <v-data-table
                  :headers="headers"
                  :items="turnos"
                  :loading="loading"
                  class="elevation-1" hide-actions>
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <tr @click="reservarTurno(props.item)">
                  <td class="text-xs-center">{{ props.item.sede }}</td>
                  <td class="text-xs-center">{{ props.item.direccion }}</td>
                    <td class="text-xs-center">{{ props.item.fecha }}</td>
                    <td class="text-xs-center">{{ props.item.tramites }}</td>
                    <!--
                    <td class="justify-center layout px-0">
                      <v-icon small class="mr-2" @click="reservarTurno(props.item)">
                        edit
                      </v-icon>
                    </td>
                    -->
                  </tr>
                </template>
                <template slot="no-data">
                  <v-alert :value="true" icon="info" color="primary" outline class="text-xs-center">
                    Para ver los turnos disponibles, busque por sede luego por servicio y por ultimo por clasificacion
                  </v-alert>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">

                <p class="text-left"><strong>{{mensaje}}</strong></p>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <p class="text-left">Sede: {{turnoItem.sede}}</p>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <p class="text-left">Direccion: {{turnoItem.direccion}}</p>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                   <p class="text-left">Fecha: {{turnoItem.fecha}}</p>
                </v-col>
                <v-col cols="12">
                   <p class="text-left">Tramite: {{turnoItem.tramites}}</p>
                </v-col>

                <v-col cols="12" sm="6">
                  <p class="text-left">Seleccione la hora de la cita</p>
                   <v-radio-group  v-model="radios" :mandatory="false" row>
                      <v-radio v-for="(value, index) in ele" :label="index" :value="`${value[0]}_${index}`" required></v-radio>
                    </v-radio-group>
                    
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
          <FlashMessage></FlashMessage>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close"><v-icon class="blue--text text--lighten-2">cancel</v-icon>Cancelar</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save"><v-icon class="blue--text text--lighten-2">forward</v-icon>Reservar</v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    
    <v-dialog persistent v-model="dialogSuccess" max-width="560px">
      <v-card>
        <v-card-title class="headline blue darken-1 white--text"  primary-title>
          Cita solicitada con éxito!
        </v-card-title>
        <v-card-text>
          <p>Su cita ha sido apartada para el dia {{turnoItem.fecha}} - {{customfield}}</p>
          <p>en la sede  {{turnoItem.sede}}  de direccion {{turnoItem.direccion}}</p>
          <!--<p> lo invitamos a actualizar su informacion  en el link:  </p>-->
          <p> Por favor verificar en su numero de teléfono la confirmación de la misma. </p>
          <p><strong>{{mensaje}}</strong></p>
          <p><strong>Recuerde que para las atenciones de creacion o cambios de medios de pagos para recibir una adecuada atención es importante que tenga el medio de pago creado y activado, ya sea Ahorro a la mano, Daviplata ó Cuenta Digital AV Villas.</strong></p>
          <!--<p><strong><a href="https://actualizacion.cajamag.com.co/afiliado">Actualizar informacion</a></strong></p>-->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="closeSuccess"><v-icon class="blue--text text--lighten-2">chevron_right</v-icon>Finalizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogLoading"
        hide-overlay
        persistent
        width="300"
    >
      <v-card color="primary" dark
      >
        <v-card-text>
          Por favor, espere...
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-content>
  

</template>

<script>
  import {turnoService} from "../services/turnoService"
  import {router} from "../router";

  export default {
    data: () => ({
     ele:'',
     elk:'',
      customfield:'',
      sede:'',
      horas: '',
      servicio:'',
      radios: '',
      mensaje: '',
      clasificacion:'',
      sedes: [],
      servicios: [],
      clasificaciones: [],
      loading: false,
      dialog: false,
      dialogLoading: false,
      dialogSuccess: false,
      headers: [
        {text: 'Sede', value: 'sede', align: 'center'},
        {text: 'Direccion', value: 'direccion', align: 'center'},
        {text: 'Día', value: 'fecha', align: 'center'},
        {text: 'Tramites', value: 'tramites', align: 'center'},
      ],
      turnoIndex: -1,
      turnoItem: {
        id: '',
        fecha: '',
        sede:'',
        direccion:'',
        hora: '',
        medico: '',
        especialidad: '',
        sede: '',
      },
    }),
    computed: {
      turnos() {
        return this.$store.state.turnos.all
      },
      
      paciente () {
        return this.$store.state.paciente.data
      }

    },
    created() {
      turnoService.findByClasificacionNuevoMedio().then(data=>this.clasificaciones = data)
    },
    watch: {
      dialog(val) {
        val || this.close()
      },
      dialogLoading(val) {
        val || this.close()
      },
    },
    methods: {
      
      
      onTurnoClasificacionChange(clasificacion) {
        this.clasificacion = clasificacion;
        this.$store.dispatch('turnos/findByClasificacion', {clasificacion});

      },
        
      onEspecialidadChange(especialidad) {
        this.$store.dispatch('turnos/findByEspecialidad', {especialidad});
      },
      reservarTurno(item) {
        /*let diaPicoCedula = JSON.parse(localStorage.getItem('horario'));*/
        console.log("reservarTurno");
        this.radios = [];
        this.turnoIndex = this.turnos.indexOf(item)
        this.turnoItem = Object.assign({}, item)
        let fec = new Date(this.turnoItem.fecha);
        if(this.turnoItem.vir_tual=="S"){
          this.mensaje = "Recuerde: Señor Afiliado que  la atención se realizará a través de videollamada y que para ello se requiere: Tener descargado el aplicativo zoom en su celular o computador, tener cámara y micrófono y tener a la mano el documento de identificación en original.Así como tener el medio de pago creado y activado, ya sea Ahorro a la mano, Daviplata ó Cuenta Digital AV Villas.";
        }else{
          this.mensaje="";
        }
        console.log(fec.getDay());
        /*console.log(diaPicoCedula);
        if(fec.getDay()!=diaPicoCedula){
          alert('No puede reservar cita para este dia');
          return false;  
        }*/

        
  //////////CODE JC//////////////
    let citas={}
    var horas=this.turnoItem.hora.split(',');
    for(var hora in horas){
      citas[horas[hora].split('_')[1]] = citas[horas[hora].split('_')[1]] || [];
      citas[horas[hora].split('_')[1]].push(horas[hora].split('_')[0]);
      citas[horas[hora].split('_')[1]].sort(function (a, b) {
        if (a.valor > b.valor) {
          //return 1;
          return Math.floor(-1 + Math.random()*(3));
        }
        if (a.valor < b.valor) {
          //return -1;
          return Math.floor(-1 + Math.random()*(3));
        }
        //return 0;
        return Math.floor(-1 + Math.random()*(3));
      }); 
    }
    var sortable = [];
    for (var cita in citas) {
      sortable.push([cita, citas[cita]]);
    }

    sortable.sort(function(a, b) {
      //console.log(a[0].replace(':','')," ",b[0].replace(':',''))
      return a[0].replace(':','') - b[0].replace(':','');
    });

    var result = {}
    sortable.forEach(function(item){
      result[item[0]]=item[1];
    })
   
         console.log(result);
     
         this.ele = result;
         this.dialog = true
      },
      close() {
        this.dialog = false
      },
      closeSuccess() {
        this.dialogSuccess = false
        router.push('/')
      },
      save() {

        let fec = this.turnoItem.fecha;
        console.log("saving...");
        let datosPaciente = JSON.parse(localStorage.getItem('inte'));
        
        let documento = ""; let celular = ""; let email = "";

        if(Array.isArray(datosPaciente)){
          console.log("if");
          documento = datosPaciente[0].documento;
          celular = datosPaciente[0].celular;
          email = datosPaciente[0].email;
        }else{
          console.log("else");
          documento = datosPaciente.documento;
          celular = datosPaciente.celular;
          email = datosPaciente.email;
        }

        let pacienteId = null;
        
        if(this.radios.length==0){
          this.flashMessage.show({status: 'error', title: 'Error', message: 'Debe seleccionar un hora!!'})
          return false;
        }
        
        let t = this.radios.split("_");
        this.customfield = t[1];
        this.dialogLoading = true;

        turnoService.reservarTurno(t[0], documento, celular, email,this.clasificacion).then(
          data => {
           if(data.status==200 && data.data.success){
              this.dialogLoading = false;
              this.dialogSuccess = true;
              localStorage.clear();
              this.$store.state.turnos.all = [];
            }else{
              this.dialogLoading = false;
              alert(data.data.msj);
            }
          },
          error => {
            console.log("error saving...");
          }
        );
        console.log("close...");
        this.close()
      },
    },
  }
</script>
<style>
  .v-alert {
    margin: 90px 0 90px 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/ReservacionTurnoMedio.vue